module.exports = __webpack_public_path__ + "public/img/detail.4b39acd9.png";